export default __webpack_public_path__ + "static/media/bg.6dd239b8.svg";